module.exports = __webpack_public_path__ + "static/IMG_4900-e8300b276e58b4d41369f77e35135908.jpg";